export const sxConfig = {
  page: {
    height: { xs: '100vh', md: 'calc(100vh - 57px)' },
    bgcolor: '#E9F5FE',
    p: 1,
    overflow: 'hidden',
    boxSizing: 'border-box',
  },

  gridPanel: {
    height: '100%',
    minHeight: 0,
    minWidth: 0,
  },

  panel: {
    backgroundColor: 'white',
    border: '1px solid #DCE5F0',
    borderRadius: 2,
    height: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },

  leftPanel: {
    p: { xs: 1, md: 1.5 },
    overflowY: 'auto',
  },

  rightPanel: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    '& form': {
      flex: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  },

  formContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },

  formContent: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    p: { xs: 1, md: 1.5 },
  },

  formFooter: {
    flexShrink: 0,
    borderTop: '1px solid #DCE5F0',
    p: { xs: 1, md: 1.5 },
    bgcolor: 'white',
  },

  emptyState: {
    height: '100%',
    color: '#7d9eb0',
  },

  emptyList: {
    color: '#7d9eb0',
    pt: 2,
  },

  sectionTitle: {
    fontSize: 20,
    mb: 1,
  },

  addButton: {
    textTransform: 'none',
    fontWeight: 600,
  },

  backToListButton: {
    m: 1,
    textTransform: 'none',
    backgroundColor: '#E3F2FD',
    color: '#007BFF',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#D0E8FC',
    },
  },

  navigationIconButton: {
    border: '1px solid #DCE5F0',
    backgroundColor: '#F6FAFF',
    borderRadius: 2,
  },

  footerButton: {
    textTransform: 'none',
    fontWeight: 600,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },

  previousButton: {
    backgroundColor: '#E3F2FD',
    color: '#007BFF',
    '&:hover': {
      backgroundColor: '#D0E8FC',
    },
  },

  nextButton: {
    backgroundColor: '#087BEE',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#0069D4',
    },
  },

  saveButton: {
    backgroundColor: '#52D55F',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#3FC74D',
    },
  },

  closeButton: {
    backgroundColor: '#EDF2F6',
    borderColor: '#EDF2F6',
    color: '#526579',
    '&:hover': {
      backgroundColor: '#DFE7ED',
      borderColor: '#DFE7ED',
    },
  },

  operationChip: (operationColor) => ({
    color: operationColor?.textColor,
    backgroundColor: operationColor?.colorBgCode,
  }),

  transportCard: (isSelected) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    px: 1,
    py: 1.5,
    mb: 1,
    minHeight: 70,
    border: '1px solid',
    backgroundColor: isSelected ? '#F6FAFF' : 'white',
    borderRadius: 1.5,
    cursor: 'pointer',
    borderColor: isSelected ? '#1682FF' : '#DCE5F0',
  }),

  dragIcon: {
    fontSize: 20,
    color: '#718BAB',
    flexShrink: 0,
  },

  deleteButton: {
    color: '#A85664',
    p: 0.5,
    width: 26,
    height: 26,
    flexShrink: 0,
  },

  deleteIcon: {
    fontSize: 17,
  },

  operationButton: (isSelected, operationColor) => ({
    textTransform: 'none',
    borderColor: isSelected ? operationColor?.textColor : '#DCE5F0',
    backgroundColor: isSelected ? operationColor?.colorBgCode : 'white',
    color: isSelected ? operationColor?.textColor : '#09275E',
    minWidth: 100,
    height: 40,
    px: { xs: 1, md: 2 },
    fontSize: { xs: 12, md: 14 },
    '&:hover': {
      borderColor: isSelected ? operationColor?.textColor : '#DCE5F0',
      backgroundColor: isSelected ? operationColor?.colorBgCode : '#F5F9FF',
    },
  }),

  addMaterialButton: {
    fontSize: 16,
  },

  statusCheckbox: (statusColor) => ({
    p: 0,
    m: 0,
    backgroundColor: statusColor?.colorBgCode,
    color: statusColor?.textColor,
    borderRadius: 1,
    '&.Mui-checked': {
      color: statusColor?.textColor,
    },
    '&:hover': {
      backgroundColor: statusColor?.colorBgCode,
    },
    '& .MuiSvgIcon-root': {
      fontSize: 35,
    },
  }),

  transportHeader: {
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'stretch', md: 'center' },
    justifyContent: 'space-between',
    gap: 2,
    mb: 1,
  },

  transportHeaderTitle: {
    flex: 1,
    minWidth: 0,
  },

  transportTitle: {
    fontSize: { xs: 17, md: 20 },
    fontWeight: 600,
    minWidth: 0,
    overflowWrap: 'break-word',
  },

  transportHeaderChip: {
    flexShrink: 0,
  },

  transportNavigation: {
    width: { xs: '100%', md: 'auto' },
    flexShrink: 0,
    justifyContent: 'space-between',
  },

  transportOrderText: {
    fontSize: 14,
    color: 'text.secondary',
  },

  addCardButton: {
    mt: 1,
  },
};
